import http from '@/service/service2'

export function login(params?: any) {
  const url = '/sys/user/login?username=' + params.username + '&' + 'password=' + params.password
  return http.post(url)
}
// export function login1(params?: any) {
//   const url = '/login'
//   return http.post(url, params)
// }
// export function menuList(params?: any) {
//   const url = '/menus'
//   return http.get(url)
// }
/**
 * @returns 应用客户端id
 */
export async function getMenuList() {
  return await http.get('/sys/login/getMenuList')
}
export async function getUserInfo() {
  return await http.get('/sys/login/getUserInfo')
}

export async function logout() {
  return await http.post('/sys/login/logout')
}
export async function refreshToken(params: any) {
  return http.post('/sys/login/refreshToken', params)
}
export async function putFileAttach(params: any) {
  return await http.post('/sys/face/register', params)
}
export async function faceLogin(params: any) {
  return await http.post('/sys/face/faceLogin', params)
}
export async function updatePasswordByUser(id: any, pass: any) {
  return await http.get(`/sys/login/updatePasswordByUser/${id}/${pass}`)
}

export async function getcaptcha() {
  return await http.get('/captcha')
}
export async function validatorCaptchaImage(code: string) {
  return await http.get(`/validatorCaptchaImage/${code}`)
}
// 统一身份认证
export async function tongyishenfen(url?: string) {
  return await http.get('sys/oauth/getCodeUrl/0')
}
